var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSandCastle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 297.93 155.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e6141e;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m187.35.84v-.84h5.5v.84h-5.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m194.83.84v-.84h5.5v.84h-5.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m202.31.84v-.84h5.5v.84h-5.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m209.79.84v-.84h5.5v.84h-5.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m134.6,14.48l5.29-9.43h1l-5.28,9.43h-1.01Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m142.44,12.6l2.17-5.62h1.22l2.18,5.62h-1.06l-1.73-4.54-1.72,4.54h-1.07Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m154.84,14.48l-5.28-9.43h1l5.29,9.43h-1.01Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m179.48,14.48l5.29-9.43h1l-5.28,9.43h-1.01Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m196.2,10.19v-1.14h2.78v1.14h-2.78Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m203.68,10.19v-1.14h2.78v1.14h-2.78Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m219.28,5.05c.57.64,1,1.36,1.3,2.16.3.8.45,1.63.45,2.49s-.15,1.67-.45,2.47c-.3.8-.73,1.52-1.3,2.16h-.7c.26-.42.5-.89.7-1.4.21-.51.37-1.04.49-1.59s.18-1.1.18-1.63-.06-1.09-.18-1.64-.28-1.09-.49-1.6c-.21-.51-.45-.98-.71-1.4h.7Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m127.12,27.68l5.29-9.43h1l-5.28,9.43h-1.01Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m144.77,28v-10.12h.9v10.12h-.9Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m162.32,27.68l-5.28-9.43h1l5.29,9.43h-1.01Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m175.89,27.52c-.56-.64-1-1.36-1.3-2.16-.3-.8-.45-1.63-.45-2.49s.15-1.68.45-2.48c.3-.8.73-1.52,1.3-2.16h.7c-.26.42-.49.88-.7,1.4-.21.51-.37,1.04-.5,1.59-.12.55-.18,1.1-.18,1.64s.06,1.08.18,1.64c.12.56.28,1.09.49,1.61.21.51.44.98.7,1.4h-.7Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m179.87,27.24v-.84h5.5v.84h-5.5Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m187.35,27.24v-.84h5.5v.84h-5.5Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m194.83,27.24v-.84h5.5v.84h-5.5Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m202.31,27.24v-.84h5.5v.84h-5.5Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m209.4,27.68l5.29-9.43h1l-5.28,9.43h-1.01Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m119.64,40.88l5.29-9.43h1l-5.28,9.43h-1.01Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m137.29,41.2v-10.12h.9v10.12h-.9Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m152.25,41.2v-10.12h.9v10.12h-.9Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m169.8,40.88l-5.28-9.43h1l5.29,9.43h-1.01Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m179.48,40.88l5.29-9.43h1l-5.28,9.43h-1.01Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m194.44,40.88l5.29-9.43h1l-5.28,9.43h-1.01Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m112.16,54.08l5.29-9.43h1l-5.28,9.43h-1.01Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m120.03,53.64v-.84h5.5v.84h-5.5Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m129.81,54.4v-10.12h.9v10.12h-.9Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m134.99,53.64v-.84h5.5v.84h-5.5Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m144.77,54.4v-10.12h.9v10.12h-.9Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m149.95,53.64v-.84h5.5v.84h-5.5Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m159.73,54.4v-10.12h.9v10.12h-.9Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m164.91,53.64v-.84h5.5v.84h-5.5Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m172,54.08l5.29-9.43h1l-5.28,9.43h-1.01Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m186.96,54.08l5.29-9.43h1l-5.28,9.43h-1.01Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m122.33,67.6v-10.12h.9v10.12h-.9Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m164.52,67.28l5.29-9.43h1l-5.28,9.43h-1.01Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m179.48,67.28l5.29-9.43h1l-5.28,9.43h-1.01Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m7.83,80.04v-.84h5.5v.84h-5.5Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m15.31,80.04v-.84h5.5v.84h-5.5Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m52.71,80.04v-.84h5.5v.84h-5.5Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m60.19,80.04v-.84h5.5v.84h-5.5Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m97.59,80.04v-.84h5.5v.84h-5.5Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m105.07,80.04v-.84h5.5v.84h-5.5Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m122.33,80.8v-10.12h.9v10.12h-.9Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m157.04,80.48l5.29-9.43h1l-5.28,9.43h-1.01Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m172,80.48l5.29-9.43h1l-5.28,9.43h-1.01Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m179.87,80.04v-.84h5.5v.84h-5.5Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m187.35,80.04v-.84h5.5v.84h-5.5Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m224.75,80.04v-.84h5.5v.84h-5.5Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m232.23,80.04v-.84h5.5v.84h-5.5Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m269.64,80.04v-.84h5.5v.84h-5.5Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m277.12,80.04v-.84h5.5v.84h-5.5Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m2.46,93.57v-9.32h2.27v.64h-1.21v8.04h1.21v.64h-2.27Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m26.18,84.25v9.32h-2.27v-.64h1.21v-8.04h-1.21v-.64h2.27Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m30.27,93.24v-.84h5.5v.84h-5.5Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m37.75,93.24v-.84h5.5v.84h-5.5Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m47.34,93.57v-9.32h2.27v.64h-1.21v8.04h1.21v.64h-2.27Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m71.06,84.25v9.32h-2.27v-.64h1.21v-8.04h-1.21v-.64h2.27Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m75.15,93.24v-.84h5.5v.84h-5.5Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m82.63,93.24v-.84h5.5v.84h-5.5Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m92.23,93.57v-9.32h2.27v.64h-1.21v8.04h1.21v.64h-2.27Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m115.94,84.25v9.32h-2.27v-.64h1.21v-8.04h-1.21v-.64h2.27Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m122.01,91.8v-1.46h1.54v1.46h-1.54Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m149.56,93.68l5.29-9.43h1l-5.28,9.43h-1.01Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m164.52,93.68l5.29-9.43h1l-5.28,9.43h-1.01Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m174.51,93.57v-9.32h2.27v.64h-1.21v8.04h1.21v.64h-2.27Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m198.22,84.25v9.32h-2.27v-.64h1.21v-8.04h-1.21v-.64h2.27Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m202.31,93.24v-.84h5.5v.84h-5.5Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m209.79,93.24v-.84h5.5v.84h-5.5Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m219.39,93.57v-9.32h2.27v.64h-1.21v8.04h1.21v.64h-2.27Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m243.1,84.25v9.32h-2.27v-.64h1.21v-8.04h-1.21v-.64h2.27Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m247.2,93.24v-.84h5.5v.84h-5.5Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m254.67,93.24v-.84h5.5v.84h-5.5Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m264.27,93.57v-9.32h2.27v.64h-1.21v8.04h1.21v.64h-2.27Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m287.98,84.25v9.32h-2.27v-.64h1.21v-8.04h-1.21v-.64h2.27Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m2.65,107.2v-10.12h.9v10.12h-.9Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m7.83,106.44v-.84h5.5v.84h-5.5Z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m15.31,106.44v-.84h5.5v.84h-5.5Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m112.55,106.44v-.84h5.5v.84h-5.5Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m120.03,106.44v-.84h5.5v.84h-5.5Z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m127.51,106.44v-.84h5.5v.84h-5.5Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m134.99,106.44v-.84h5.5v.84h-5.5Z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m142.08,106.88l5.29-9.43h1l-5.28,9.43h-1.01Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m157.04,106.88l5.29-9.43h1l-5.28,9.43h-1.01Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m164.91,106.44v-.84h5.5v.84h-5.5Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m172.39,106.44v-.84h5.5v.84h-5.5Z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m179.87,106.44v-.84h5.5v.84h-5.5Z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m269.64,106.44v-.84h5.5v.84h-5.5Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m277.12,106.44v-.84h5.5v.84h-5.5Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m286.89,107.2v-10.12h.9v10.12h-.9Z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m25.09,120.4v-10.12h.9v10.12h-.9Z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m104.68,120.08l5.29-9.43h1l-5.28,9.43h-1.01Z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m122.01,118.2v-1.46h1.54v1.46h-1.54Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m128.88,115.79v-1.14h2.78v1.14h-2.78Z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m136.36,115.79v-1.14h2.78v1.14h-2.78Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m143.84,115.79v-1.14h2.78v1.14h-2.78Z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m151.32,115.79v-1.14h2.78v1.14h-2.78Z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m158.8,115.79v-1.14h2.78v1.14h-2.78Z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m166.28,115.79v-1.14h2.78v1.14h-2.78Z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m189.36,110.65c.56.64,1,1.36,1.3,2.16.3.8.45,1.63.45,2.49s-.15,1.67-.45,2.47c-.3.8-.73,1.52-1.3,2.16h-.7c.26-.43.5-.89.7-1.4.21-.51.37-1.04.49-1.6s.18-1.1.18-1.63-.06-1.09-.18-1.64-.28-1.09-.49-1.6c-.21-.51-.45-.98-.71-1.4h.7Z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m264.45,120.4v-10.12h.9v10.12h-.9Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m25.09,133.6v-10.12h.9v10.12h-.9Z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m97.2,133.28l5.29-9.43h1l-5.28,9.43h-1.01Z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m112.16,133.28l5.29-9.43h1l-5.28,9.43h-1.01Z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m179.48,133.28l5.29-9.43h1l-5.28,9.43h-1.01Z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m264.45,133.6v-10.12h.9v10.12h-.9Z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m25.09,146.8v-10.12h.9v10.12h-.9Z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m89.72,146.48l5.29-9.43h1l-5.28,9.43h-1.01Z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m104.68,146.48l5.29-9.43h1l-5.28,9.43h-1.01Z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m172,146.48l5.29-9.43h1l-5.28,9.43h-1.01Z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m264.45,146.8v-10.12h.9v10.12h-.9Z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m0,155.5v-.98c.11-.12.25-.25.43-.38.18-.13.38-.24.62-.34s.48-.14.75-.14c.23,0,.46.04.67.11s.42.16.63.25c.21.1.42.18.63.25.22.07.45.11.69.11.26,0,.51-.05.74-.14.23-.09.44-.2.62-.33.18-.13.33-.26.43-.39v.98c-.1.12-.25.25-.43.38-.18.13-.39.24-.62.34-.23.09-.48.14-.74.14-.24,0-.46-.04-.67-.11-.21-.07-.42-.16-.63-.25-.21-.1-.42-.18-.63-.25-.22-.07-.45-.11-.69-.11-.26,0-.51.05-.75.14s-.44.2-.62.33c-.18.13-.32.26-.43.39Z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m7.48,155.5v-.98c.11-.12.25-.25.43-.38s.38-.24.62-.34c.23-.09.48-.14.75-.14.23,0,.46.04.67.11.21.07.42.16.63.25.21.1.42.18.63.25.22.07.45.11.69.11.26,0,.51-.05.74-.14.23-.09.44-.2.62-.33.18-.13.33-.26.43-.39v.98c-.1.12-.25.25-.43.38s-.39.24-.62.34c-.23.09-.48.14-.74.14-.23,0-.46-.04-.67-.11s-.42-.16-.63-.25c-.21-.1-.42-.18-.63-.25-.22-.07-.45-.11-.69-.11-.26,0-.51.05-.75.14-.24.09-.44.2-.62.33-.18.13-.32.26-.43.39Z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m14.96,155.5v-.98c.11-.12.25-.25.43-.38.18-.13.38-.24.62-.34s.48-.14.75-.14c.23,0,.46.04.67.11s.42.16.63.25c.21.1.42.18.63.25.22.07.45.11.69.11.26,0,.51-.05.74-.14.23-.09.44-.2.62-.33.18-.13.33-.26.43-.39v.98c-.1.12-.25.25-.43.38-.18.13-.39.24-.62.34-.23.09-.48.14-.74.14-.24,0-.46-.04-.67-.11-.21-.07-.42-.16-.63-.25-.21-.1-.42-.18-.63-.25-.22-.07-.45-.11-.69-.11-.26,0-.51.05-.75.14s-.44.2-.62.33c-.18.13-.32.26-.43.39Z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m22.44,155.5v-.98c.11-.12.25-.25.43-.38.18-.13.38-.24.62-.34s.48-.14.75-.14c.23,0,.46.04.67.11s.42.16.63.25c.21.1.42.18.63.25.22.07.45.11.69.11.26,0,.51-.05.74-.14.23-.09.44-.2.62-.33.18-.13.33-.26.43-.39v.98c-.1.12-.25.25-.43.38-.18.13-.39.24-.62.34-.23.09-.48.14-.74.14-.24,0-.46-.04-.67-.11-.21-.07-.42-.16-.63-.25-.21-.1-.42-.18-.63-.25-.22-.07-.45-.11-.69-.11-.26,0-.51.05-.75.14s-.44.2-.62.33c-.18.13-.32.26-.43.39Z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m29.92,155.5v-.98c.11-.12.25-.25.43-.38s.38-.24.62-.34c.23-.09.48-.14.75-.14.23,0,.46.04.67.11.21.07.42.16.63.25.21.1.42.18.63.25.22.07.45.11.69.11.26,0,.51-.05.74-.14.23-.09.44-.2.62-.33.18-.13.33-.26.43-.39v.98c-.1.12-.25.25-.43.38s-.39.24-.62.34c-.23.09-.48.14-.74.14-.23,0-.46-.04-.67-.11s-.42-.16-.63-.25c-.21-.1-.42-.18-.63-.25-.22-.07-.45-.11-.69-.11-.26,0-.51.05-.75.14-.24.09-.44.2-.62.33-.18.13-.32.26-.43.39Z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m37.4,155.5v-.98c.11-.12.25-.25.43-.38.18-.13.38-.24.62-.34s.48-.14.75-.14c.23,0,.46.04.67.11s.42.16.63.25c.21.1.42.18.63.25.22.07.45.11.69.11.26,0,.51-.05.74-.14.23-.09.44-.2.62-.33.18-.13.33-.26.43-.39v.98c-.1.12-.25.25-.43.38-.18.13-.39.24-.62.34-.23.09-.48.14-.74.14-.24,0-.46-.04-.67-.11-.21-.07-.42-.16-.63-.25-.21-.1-.42-.18-.63-.25-.22-.07-.45-.11-.69-.11-.26,0-.51.05-.75.14s-.44.2-.62.33c-.18.13-.32.26-.43.39Z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m44.88,155.5v-.98c.11-.12.25-.25.43-.38s.38-.24.62-.34c.23-.09.48-.14.75-.14.23,0,.46.04.67.11.21.07.42.16.63.25.21.1.42.18.63.25.22.07.45.11.69.11.26,0,.51-.05.74-.14.23-.09.44-.2.62-.33.18-.13.33-.26.43-.39v.98c-.1.12-.25.25-.43.38s-.39.24-.62.34c-.23.09-.48.14-.74.14-.23,0-.46-.04-.67-.11s-.42-.16-.63-.25c-.21-.1-.42-.18-.63-.25-.22-.07-.45-.11-.69-.11-.26,0-.51.05-.75.14-.24.09-.44.2-.62.33-.18.13-.32.26-.43.39Z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m52.36,155.5v-.98c.11-.12.25-.25.43-.38s.38-.24.62-.34c.23-.09.48-.14.75-.14.23,0,.46.04.67.11.21.07.42.16.63.25.21.1.42.18.63.25.22.07.45.11.69.11.26,0,.51-.05.74-.14.23-.09.44-.2.62-.33.18-.13.33-.26.43-.39v.98c-.1.12-.25.25-.43.38s-.39.24-.62.34c-.23.09-.48.14-.74.14-.23,0-.46-.04-.67-.11s-.42-.16-.63-.25c-.21-.1-.42-.18-.63-.25-.22-.07-.45-.11-.69-.11-.26,0-.51.05-.75.14-.24.09-.44.2-.62.33-.18.13-.32.26-.43.39Z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m59.84,155.5v-.98c.11-.12.25-.25.43-.38.18-.13.38-.24.62-.34s.48-.14.75-.14c.23,0,.46.04.67.11s.42.16.63.25c.21.1.42.18.63.25.22.07.45.11.69.11.26,0,.51-.05.74-.14.23-.09.44-.2.62-.33.18-.13.33-.26.43-.39v.98c-.1.12-.25.25-.43.38-.18.13-.39.24-.62.34-.23.09-.48.14-.74.14-.24,0-.46-.04-.67-.11-.21-.07-.42-.16-.63-.25-.21-.1-.42-.18-.63-.25-.22-.07-.45-.11-.69-.11-.26,0-.51.05-.75.14s-.44.2-.62.33c-.18.13-.32.26-.43.39Z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m67.32,155.5v-.98c.11-.12.25-.25.43-.38s.38-.24.62-.34c.23-.09.48-.14.75-.14.23,0,.46.04.67.11.21.07.42.16.63.25.21.1.42.18.63.25.22.07.45.11.69.11.26,0,.51-.05.74-.14.23-.09.44-.2.62-.33.18-.13.33-.26.43-.39v.98c-.1.12-.25.25-.43.38s-.39.24-.62.34c-.23.09-.48.14-.74.14-.23,0-.46-.04-.67-.11s-.42-.16-.63-.25c-.21-.1-.42-.18-.63-.25-.22-.07-.45-.11-.69-.11-.26,0-.51.05-.75.14-.24.09-.44.2-.62.33-.18.13-.32.26-.43.39Z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m74.8,155.5v-.98c.11-.12.25-.25.43-.38.18-.13.38-.24.62-.34s.48-.14.75-.14c.23,0,.46.04.67.11s.42.16.63.25c.21.1.42.18.63.25.22.07.45.11.69.11.26,0,.51-.05.74-.14.23-.09.44-.2.62-.33.18-.13.33-.26.43-.39v.98c-.1.12-.25.25-.43.38-.18.13-.39.24-.62.34-.23.09-.48.14-.74.14-.24,0-.46-.04-.67-.11-.21-.07-.42-.16-.63-.25-.21-.1-.42-.18-.63-.25-.22-.07-.45-.11-.69-.11-.26,0-.51.05-.75.14s-.44.2-.62.33c-.18.13-.32.26-.43.39Z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m82.28,155.5v-.98c.11-.12.25-.25.43-.38.18-.13.38-.24.62-.34s.48-.14.75-.14c.23,0,.46.04.67.11s.42.16.63.25c.21.1.42.18.63.25.22.07.45.11.69.11.26,0,.51-.05.74-.14.23-.09.44-.2.62-.33.18-.13.33-.26.43-.39v.98c-.1.12-.25.25-.43.38-.18.13-.39.24-.62.34-.23.09-.48.14-.74.14-.24,0-.46-.04-.67-.11-.21-.07-.42-.16-.63-.25-.21-.1-.42-.18-.63-.25-.22-.07-.45-.11-.69-.11-.26,0-.51.05-.75.14s-.44.2-.62.33c-.18.13-.32.26-.43.39Z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m91.48,155.39v-1.14h2.78v1.14h-2.78Z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m98.96,155.39v-1.14h2.78v1.14h-2.78Z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m106.44,155.39v-1.14h2.78v1.14h-2.78Z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m113.92,155.39v-1.14h2.78v1.14h-2.78Z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m121.4,155.39v-1.14h2.78v1.14h-2.78Z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m128.88,155.39v-1.14h2.78v1.14h-2.78Z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m136.36,155.39v-1.14h2.78v1.14h-2.78Z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m143.84,155.39v-1.14h2.78v1.14h-2.78Z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m151.32,155.39v-1.14h2.78v1.14h-2.78Z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m158.8,155.39v-1.14h2.78v1.14h-2.78Z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m166.28,155.39v-1.14h2.78v1.14h-2.78Z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m172.04,155.5v-.98c.11-.12.25-.25.43-.38s.38-.24.62-.34c.23-.09.48-.14.75-.14.23,0,.46.04.67.11.21.07.42.16.63.25.21.1.42.18.63.25.22.07.45.11.69.11.26,0,.51-.05.74-.14.23-.09.44-.2.62-.33.18-.13.33-.26.43-.39v.98c-.1.12-.25.25-.43.38s-.39.24-.62.34c-.23.09-.48.14-.74.14-.23,0-.46-.04-.67-.11s-.42-.16-.63-.25c-.21-.1-.42-.18-.63-.25-.22-.07-.45-.11-.69-.11-.26,0-.51.05-.75.14-.24.09-.44.2-.62.33-.18.13-.32.26-.43.39Z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m179.52,155.5v-.98c.11-.12.25-.25.43-.38.18-.13.38-.24.62-.34s.48-.14.75-.14c.23,0,.46.04.67.11s.42.16.63.25c.21.1.42.18.63.25.22.07.45.11.69.11.26,0,.51-.05.74-.14.23-.09.44-.2.62-.33.18-.13.33-.26.43-.39v.98c-.1.12-.25.25-.43.38-.18.13-.39.24-.62.34-.23.09-.48.14-.74.14-.24,0-.46-.04-.67-.11-.21-.07-.42-.16-.63-.25-.21-.1-.42-.18-.63-.25-.22-.07-.45-.11-.69-.11-.26,0-.51.05-.75.14s-.44.2-.62.33c-.18.13-.32.26-.43.39Z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m187,155.5v-.98c.11-.12.25-.25.43-.38s.38-.24.62-.34c.23-.09.48-.14.75-.14.23,0,.46.04.67.11.21.07.42.16.63.25.21.1.42.18.63.25.22.07.45.11.69.11.26,0,.51-.05.74-.14.23-.09.44-.2.62-.33.18-.13.33-.26.43-.39v.98c-.1.12-.25.25-.43.38s-.39.24-.62.34c-.23.09-.48.14-.74.14-.23,0-.46-.04-.67-.11s-.42-.16-.63-.25c-.21-.1-.42-.18-.63-.25-.22-.07-.45-.11-.69-.11-.26,0-.51.05-.75.14-.24.09-.44.2-.62.33-.18.13-.32.26-.43.39Z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m194.48,155.5v-.98c.11-.12.25-.25.43-.38.18-.13.38-.24.62-.34s.48-.14.75-.14c.23,0,.46.04.67.11s.42.16.63.25c.21.1.42.18.63.25.22.07.45.11.69.11.26,0,.51-.05.74-.14.23-.09.44-.2.62-.33.18-.13.33-.26.43-.39v.98c-.1.12-.25.25-.43.38-.18.13-.39.24-.62.34-.23.09-.48.14-.74.14-.24,0-.46-.04-.67-.11-.21-.07-.42-.16-.63-.25-.21-.1-.42-.18-.63-.25-.22-.07-.45-.11-.69-.11-.26,0-.51.05-.75.14s-.44.2-.62.33c-.18.13-.32.26-.43.39Z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m201.96,155.5v-.98c.11-.12.25-.25.43-.38.18-.13.38-.24.62-.34s.48-.14.75-.14c.23,0,.46.04.67.11s.42.16.63.25c.21.1.42.18.63.25.22.07.45.11.69.11.26,0,.51-.05.74-.14.23-.09.44-.2.62-.33.18-.13.33-.26.43-.39v.98c-.1.12-.25.25-.43.38-.18.13-.39.24-.62.34-.23.09-.48.14-.74.14-.24,0-.46-.04-.67-.11-.21-.07-.42-.16-.63-.25-.21-.1-.42-.18-.63-.25-.22-.07-.45-.11-.69-.11-.26,0-.51.05-.75.14s-.44.2-.62.33c-.18.13-.32.26-.43.39Z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m209.44,155.5v-.98c.11-.12.25-.25.43-.38s.38-.24.62-.34c.23-.09.48-.14.75-.14.23,0,.46.04.67.11.21.07.42.16.63.25.21.1.42.18.63.25.22.07.45.11.69.11.26,0,.51-.05.74-.14.23-.09.44-.2.62-.33.18-.13.33-.26.43-.39v.98c-.1.12-.25.25-.43.38s-.39.24-.62.34c-.23.09-.48.14-.74.14-.23,0-.46-.04-.67-.11s-.42-.16-.63-.25c-.21-.1-.42-.18-.63-.25-.22-.07-.45-.11-.69-.11-.26,0-.51.05-.75.14-.24.09-.44.2-.62.33-.18.13-.32.26-.43.39Z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m216.92,155.5v-.98c.11-.12.25-.25.43-.38.18-.13.38-.24.62-.34s.48-.14.75-.14c.23,0,.46.04.67.11s.42.16.63.25c.21.1.42.18.63.25.22.07.45.11.69.11.26,0,.51-.05.74-.14.23-.09.44-.2.62-.33.18-.13.33-.26.43-.39v.98c-.1.12-.25.25-.43.38-.18.13-.39.24-.62.34-.23.09-.48.14-.74.14-.24,0-.46-.04-.67-.11-.21-.07-.42-.16-.63-.25-.21-.1-.42-.18-.63-.25-.22-.07-.45-.11-.69-.11-.26,0-.51.05-.75.14s-.44.2-.62.33c-.18.13-.32.26-.43.39Z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m224.4,155.5v-.98c.11-.12.25-.25.43-.38s.38-.24.62-.34c.23-.09.48-.14.75-.14.23,0,.46.04.67.11.21.07.42.16.63.25.21.1.42.18.63.25.22.07.45.11.69.11.26,0,.51-.05.74-.14.23-.09.44-.2.62-.33.18-.13.33-.26.43-.39v.98c-.1.12-.25.25-.43.38s-.39.24-.62.34c-.23.09-.48.14-.74.14-.23,0-.46-.04-.67-.11s-.42-.16-.63-.25c-.21-.1-.42-.18-.63-.25-.22-.07-.45-.11-.69-.11-.26,0-.51.05-.75.14-.24.09-.44.2-.62.33-.18.13-.32.26-.43.39Z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m231.88,155.5v-.98c.11-.12.25-.25.43-.38.18-.13.38-.24.62-.34s.48-.14.75-.14c.23,0,.46.04.67.11s.42.16.63.25c.21.1.42.18.63.25.22.07.45.11.69.11.26,0,.51-.05.74-.14.23-.09.44-.2.62-.33.18-.13.33-.26.43-.39v.98c-.1.12-.25.25-.43.38-.18.13-.39.24-.62.34-.23.09-.48.14-.74.14-.24,0-.46-.04-.67-.11-.21-.07-.42-.16-.63-.25-.21-.1-.42-.18-.63-.25-.22-.07-.45-.11-.69-.11-.26,0-.51.05-.75.14s-.44.2-.62.33c-.18.13-.32.26-.43.39Z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m239.36,155.5v-.98c.11-.12.25-.25.43-.38.18-.13.38-.24.62-.34s.48-.14.75-.14c.23,0,.46.04.67.11s.42.16.63.25c.21.1.42.18.63.25.22.07.45.11.69.11.26,0,.51-.05.74-.14.23-.09.44-.2.62-.33.18-.13.33-.26.43-.39v.98c-.1.12-.25.25-.43.38-.18.13-.39.24-.62.34-.23.09-.48.14-.74.14-.24,0-.46-.04-.67-.11-.21-.07-.42-.16-.63-.25-.21-.1-.42-.18-.63-.25-.22-.07-.45-.11-.69-.11-.26,0-.51.05-.75.14s-.44.2-.62.33c-.18.13-.32.26-.43.39Z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m246.84,155.5v-.98c.11-.12.25-.25.43-.38s.38-.24.62-.34c.23-.09.48-.14.75-.14.23,0,.46.04.67.11.21.07.42.16.63.25.21.1.42.18.63.25.22.07.45.11.69.11.26,0,.51-.05.74-.14.23-.09.44-.2.62-.33.18-.13.33-.26.43-.39v.98c-.1.12-.25.25-.43.38s-.39.24-.62.34c-.23.09-.48.14-.74.14-.23,0-.46-.04-.67-.11s-.42-.16-.63-.25c-.21-.1-.42-.18-.63-.25-.22-.07-.45-.11-.69-.11-.26,0-.51.05-.75.14-.24.09-.44.2-.62.33-.18.13-.32.26-.43.39Z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m254.32,155.5v-.98c.11-.12.25-.25.43-.38.18-.13.38-.24.62-.34s.48-.14.75-.14c.23,0,.46.04.67.11s.42.16.63.25c.21.1.42.18.63.25.22.07.45.11.69.11.26,0,.51-.05.74-.14.23-.09.44-.2.62-.33.18-.13.33-.26.43-.39v.98c-.1.12-.25.25-.43.38-.18.13-.39.24-.62.34-.23.09-.48.14-.74.14-.24,0-.46-.04-.67-.11-.21-.07-.42-.16-.63-.25-.21-.1-.42-.18-.63-.25-.22-.07-.45-.11-.69-.11-.26,0-.51.05-.75.14s-.44.2-.62.33c-.18.13-.32.26-.43.39Z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m261.8,155.5v-.98c.11-.12.25-.25.43-.38s.38-.24.62-.34c.23-.09.48-.14.75-.14.23,0,.46.04.67.11.21.07.42.16.63.25.21.1.42.18.63.25.22.07.45.11.69.11.26,0,.51-.05.74-.14.23-.09.44-.2.62-.33.18-.13.33-.26.43-.39v.98c-.1.12-.25.25-.43.38s-.39.24-.62.34c-.23.09-.48.14-.74.14-.23,0-.46-.04-.67-.11s-.42-.16-.63-.25c-.21-.1-.42-.18-.63-.25-.22-.07-.45-.11-.69-.11-.26,0-.51.05-.75.14-.24.09-.44.2-.62.33-.18.13-.32.26-.43.39Z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m269.28,155.5v-.98c.11-.12.25-.25.43-.38s.38-.24.62-.34c.23-.09.48-.14.75-.14.23,0,.46.04.67.11.21.07.42.16.63.25.21.1.42.18.63.25.22.07.45.11.69.11.26,0,.51-.05.74-.14.23-.09.44-.2.62-.33.18-.13.33-.26.43-.39v.98c-.1.12-.25.25-.43.38s-.39.24-.62.34c-.23.09-.48.14-.74.14-.23,0-.46-.04-.67-.11s-.42-.16-.63-.25c-.21-.1-.42-.18-.63-.25-.22-.07-.45-.11-.69-.11-.26,0-.51.05-.75.14-.24.09-.44.2-.62.33-.18.13-.32.26-.43.39Z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m276.76,155.5v-.98c.11-.12.25-.25.43-.38.18-.13.38-.24.62-.34s.48-.14.75-.14c.23,0,.46.04.67.11s.42.16.63.25c.21.1.42.18.63.25.22.07.45.11.69.11.26,0,.51-.05.74-.14.23-.09.44-.2.62-.33.18-.13.33-.26.43-.39v.98c-.1.12-.25.25-.43.38-.18.13-.39.24-.62.34-.23.09-.48.14-.74.14-.24,0-.46-.04-.67-.11-.21-.07-.42-.16-.63-.25-.21-.1-.42-.18-.63-.25-.22-.07-.45-.11-.69-.11-.26,0-.51.05-.75.14s-.44.2-.62.33c-.18.13-.32.26-.43.39Z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m284.24,155.5v-.98c.11-.12.25-.25.43-.38s.38-.24.62-.34c.23-.09.48-.14.75-.14.23,0,.46.04.67.11.21.07.42.16.63.25.21.1.42.18.63.25.22.07.45.11.69.11.26,0,.51-.05.74-.14.23-.09.44-.2.62-.33.18-.13.33-.26.43-.39v.98c-.1.12-.25.25-.43.38s-.39.24-.62.34c-.23.09-.48.14-.74.14-.23,0-.46-.04-.67-.11s-.42-.16-.63-.25c-.21-.1-.42-.18-.63-.25-.22-.07-.45-.11-.69-.11-.26,0-.51.05-.75.14-.24.09-.44.2-.62.33-.18.13-.32.26-.43.39Z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m291.72,155.5v-.98c.11-.12.25-.25.43-.38.18-.13.38-.24.62-.34s.48-.14.75-.14c.23,0,.46.04.67.11s.42.16.63.25c.21.1.42.18.63.25.22.07.45.11.69.11.26,0,.51-.05.74-.14.23-.09.44-.2.62-.33.18-.13.33-.26.43-.39v.98c-.1.12-.25.25-.43.38-.18.13-.39.24-.62.34-.23.09-.48.14-.74.14-.24,0-.46-.04-.67-.11-.21-.07-.42-.16-.63-.25-.21-.1-.42-.18-.63-.25-.22-.07-.45-.11-.69-.11-.26,0-.51.05-.75.14s-.44.2-.62.33c-.18.13-.32.26-.43.39Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSandCastle);
export default __webpack_public_path__ + "static/media/sand-castle.ecb9d7217f709b5405751af119e84165.svg";
export { ForwardRef as ReactComponent };